import script from "./ChatPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ChatPanel.vue?vue&type=style&index=0&id=434b0247&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434b0247"]])

export default __exports__